const API = "https://api.sponsa.app/v1/";
//const API = "https://localhost:44375/v1/";
//const API = "https://9d22beaa3324.ngrok-free.app/v1/";
export default API;
